module.exports = __webpack_public_path__ + "img/logo1.cc9f242d.png";